"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const enums_1 = require("../../common/enums");
const store_1 = require("../../context/store");
const react_1 = require("react");
const CalendarHeaderDays_1 = __importDefault(require("./calendarHeaderDays/CalendarHeaderDays"));
const CalendarHeaderEvents_1 = __importDefault(require("./calendarHeaderEvents/CalendarHeaderEvents"));
const CalendarHeader = (props) => {
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { isDark, width, selectedView } = store;
    const isDayView = selectedView === enums_1.CALENDAR_VIEW.DAY;
    const isMonthView = selectedView === enums_1.CALENDAR_VIEW.MONTH;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `Kalend__CalendarHeader${!isMonthView ? '-tall' : ''}${isDayView ? '-day' : ''}${isMonthView ? '-small' : ''}${isDark ? '-dark' : ''}` }, { children: [(0, jsx_runtime_1.jsx)(CalendarHeaderDays_1.default, { width: width, isMonthView: isMonthView, setViewChanged: props.setViewChanged }), !isMonthView && store.headerLayout && store.headerLayout.length ? ((0, jsx_runtime_1.jsx)(CalendarHeaderEvents_1.default, {})) : null] })));
};
exports.default = CalendarHeader;
